module.exports = __webpack_public_path__ + "static/img/logo-max.104b1dc3.png";